"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.is = exports.flatMap = exports.map = exports.chain = exports.forEach = exports.clean = exports.flatten = exports.anyEquals = void 0;
const maybemonad_1 = require("./maybemonad");
function anyEquals(x, y) {
    if (x === null || x === undefined || y === null || y === undefined) {
        return x === y;
    }
    if (x.constructor !== y.constructor) {
        return false;
    }
    if (x instanceof Function && y instanceof Function) {
        return true;
    }
    if (x instanceof RegExp) {
        return x === y;
    }
    if (x === y || x.valueOf() === y.valueOf()) {
        return true;
    }
    if (Array.isArray(x) && x.length !== y.length) {
        return false;
    }
    if (x instanceof Date) {
        return false;
    }
    if (!(x instanceof Object)) {
        return false;
    }
    if (!(y instanceof Object)) {
        return false;
    }
    const p = Object.keys(x);
    return Object.keys(y).every((i) => p.indexOf(i) !== -1) &&
        p.every((i) => anyEquals(x[i], y[i]));
}
exports.anyEquals = anyEquals;
function flatten(l, emptyFunc) {
    if (!l) {
        throw new Error("Array is empty or non-existent");
    }
    if (l.length === 0) {
        return emptyFunc ? emptyFunc() : (0, maybemonad_1.nothing)();
    }
    const unit = l[0].unit;
    const rec = (l_, r) => {
        if (l_.length === 0) {
            return unit(r);
        }
        return l_[0].flatMap((x) => rec(l_.slice(1), r.concat([x])));
    };
    const empty = [];
    return rec(l, empty);
}
exports.flatten = flatten;
function clean(coll) {
    return coll.filter((elem) => elem.hasValue).map((elem) => elem.unsafeLift());
}
exports.clean = clean;
function forEach(coll, f) {
    coll.forEach((y) => y.forEach(f));
}
exports.forEach = forEach;
function chain(monad) {
    return monad.flatMap((x) => x);
}
exports.chain = chain;
function map(f, monad) {
    return monad.map(f);
}
exports.map = map;
function flatMap(f, monad) {
    return monad.flatMap(f);
}
exports.flatMap = flatMap;
function is(f, monad) {
    return monad.hasValue && monad.map(f).unsafeLift();
}
exports.is = is;
//# sourceMappingURL=helpers.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/tsmonads/lib/src/helpers.js
// module id = 195
// module chunks = 0